export default __webpack_public_path__ + "static/media/kitchen3-after1-1920w.08b7fa7a.png";